import type React from 'react';
import type { MouseEvent } from 'react';

import * as styles from './styles';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { Button } from '@cobliteam/ui/components';

import { CloseDrawerButton } from '../../CloseDrawerButton';
import { Divider } from '../../Divider';
import { Heading1 } from '../../typography/Heading';
import { Dialog, type DialogProps } from '../Dialog/Dialog';

interface DialogWithHeaderProps extends DialogProps {
  title: string;
  shouldConfirm?: boolean;
  actions?: React.ReactNode;
  startIcon?: React.ReactNode;
  onCloseButtonClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  onStartIconButtonClick?: () => void;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const DialogWithHeader: React.FC<DialogWithHeaderProps> = ({
  title,
  shouldConfirm = false,
  children,
  actions,
  startIcon,
  onClose,
  onCloseButtonClick,
  onStartIconButtonClick,
  ...otherProps
}) => {
  const closeMethod = onCloseButtonClick || onClose;

  return (
    <Dialog onClose={onClose} {...otherProps}>
      <div className={styles.container}>
        <DialogTitle classes={{ root: styles.header }}>
          {startIcon ? (
            <Button variant='text' size='condensed' startIcon={startIcon} onClick={onStartIconButtonClick}>
              {title}
            </Button>
          ) : (
            <Heading1>{title}</Heading1>
          )}
          {closeMethod && <CloseDrawerButton onCloseConfirmed={closeMethod} shouldConfirm={shouldConfirm} />}
        </DialogTitle>
        <div className={styles.divider}>
          <Divider />
        </div>
        <DialogContent classes={{ root: styles.dialogContent }}>{children}</DialogContent>
        <DialogActions classes={{ root: styles.buttonGroup }}>{actions}</DialogActions>
      </div>
    </Dialog>
  );
};
